const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/organizations/not-a-member.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(unauthenticated)/organizations/not-a-member')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});